import React from 'react'
import { Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer'
import { CustomerAddress, DocumentDate, Footer, Header, style } from '../../document/DocumentPDF'

const InterventionPDF = ({ intervention_param: intervention, company_param: company, logo_param: img }) => {
  const customer = intervention.customer
  const styles = StyleSheet.create(style)

  const References = () => {
    if (intervention) {
      return (
        <>
          <View style={styles.rightContainer}>
            <Text style={styles.boldWithSpace}>Référence intervention</Text>
            <Text style={styles.address}>{intervention.intervention_number}</Text>
          </View>
        </>
      )
    }
  }

  const InterventionSubject = () => (
    <View>
      <View style={{ marginTop: 20 }}>
        <Text style={styles.bold}>{intervention.summary}</Text>
      </View>
      {intervention.material !== undefined && intervention.material !== null && intervention.material !== '' && (
        <View style={{ marginTop: 20 }}>
          <Text style={styles.address}>Matériel :</Text>
          <Text style={styles.address}>{intervention.material}</Text>
        </View>
      )}
      <View style={{ marginTop: 20 }}>
        <Text style={styles.address}>Description :</Text>
        <Text style={styles.address}>{intervention.description}</Text>
      </View>
      {intervention.solution !== undefined && intervention.solution !== null && intervention.solution !== '' && (
        <View style={{ marginTop: 20 }}>
          <Text style={styles.address}>Solution :</Text>
          <Text style={styles.address}>{intervention.solution}</Text>
        </View>
      )}
    </View>
  )

  const InterventionPayment = () => (
    <View style={{ marginTop: 20 }}>
      <Text style={styles.conditions}>
        Ce document ne vaut pas facture. La facture vous sera envoyée ultérieurement.
      </Text>
    </View>
  )

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <View fixed>
          <Header styles={styles} title={'INTERVENTION'} img={img} />
          <References />
          <DocumentDate date={intervention.intervention_date} styles={styles} />
        </View>
        <View style={{ flex: 0.8, marginBottom: '5px', paddingBottom: '10px' }}>
          <CustomerAddress styles={styles} company={company} customer={customer} />
          <InterventionSubject />
          <InterventionPayment />
        </View>
        <Footer company={company} styles={styles} />
      </Page>
    </Document>
  )
}

export default React.memo(InterventionPDF)
